export default __webpack_public_path__ + "static/atividades-extracurriculares-e5f007456b7935e996372fa0a014fcaf.png";